// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconImageImageNotLoaded_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0H30V22.3337L28 19.6671V2H2V21L10 9L16 18L20 14L25.396 19.4487C24.6981 19.1737 23.9143 19 23.0498 19C19.8109 19 17.2014 21.183 16.22 24H0V0Z" class="svg-bg"/>
  <path d="M23 10C24.6569 10 26 8.65685 26 7 26 5.34315 24.6569 4 23 4 21.3431 4 20 5.34315 20 7 20 8.65685 21.3431 10 23 10ZM17.8203 26C18.0553 23.2794 20.2844 21 23.0498 21 24.0998 21 24.9998 21.375 25.7498 21.9 25.6748 21.9 25.5998 21.9187 25.5248 21.9375 25.4498 21.9562 25.3748 21.975 25.2998 21.975 22.8698 21.975 20.8424 23.5852 20.2248 26H22L19 30 16 26H17.8203ZM28 23.0005 25 27.0005H26.7813C26.1712 28.9905 24.1383 30.9013 21.7 30.9013 21.55 30.9013 21.4 30.8263 21.25 30.7513 22 31.2763 22.9 31.5013 23.95 31.5013 26.6715 31.5013 28.8735 29.6184 29.1668 27.0005H31L28 23.0005Z" class="svg-bg"/>
</svg>
`;
/**
 * IconImageImageNotLoaded is a generated icon component.
 */
let IconImageImageNotLoaded = IconImageImageNotLoaded_1 = class IconImageImageNotLoaded extends IconBaseElement {
    render() {
        return html `${IconImageImageNotLoaded_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconImageImageNotLoaded.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconImageImageNotLoaded = IconImageImageNotLoaded_1 = __decorate([
    customElement('zui-icon-image-image-not-loaded')
], IconImageImageNotLoaded);
export { IconImageImageNotLoaded };
